module.exports = __webpack_public_path__ + "d8f5b7e5b2d30259dda6958a4880e57e.svg";